angular.module('dnecom')
    .controller('TaxZonesModalController', ["$scope", "$uibModalInstance", "zone", "$timeout", function ($scope, $uibModalInstance, zone, $timeout) {

        $scope.zone = angular.copy(zone || {});
        $scope.zone.countries = $scope.zone.countries || [];
        $scope.zone.states = $scope.zone.states || [];
        $scope.inputInvalid = false;
        $scope.step = 1;
        $scope.allSteps = 3;

        $scope.countries = TemplateData.value('countries');
        $scope.states = TemplateData.value('states');

        $scope.originalCountries = angular.copy($scope.countries);
        $scope.originalStates = angular.copy($scope.states);

        $scope.selectedCountry = null;

        $scope.wizardForm = {};

        $scope.countrySelectorOptions = {
            dropdownAutoWidth: true,
            width: 'auto',
            templateResult: function (item, container) {
                if ($scope.isAdded(item.id)) {
                    $(container).addClass('selected');
                }

                return item.text;
            },
            escapeMarkup: function (text) {
                return text;
            }
        };

        $scope.stateSelectorOptions = {
            dropdownAutoWidth: true,
            width: 'auto',
            templateResult: function (item, container) {
                if ($scope.isAdded($scope.selectedCountry, item.id)) {
                    $(container).addClass('selected');
                }

                return item.text;
            },
            escapeMarkup: function (text) {
                return text;
            }
        };

        var getCountryName = function (country) {
            var name = $scope.originalCountries[country.code];

            if (country.states && country.states.length) {
                name += ' (' + country.states.length + ')';
            }

            return name;
        };

        $scope.zone.countries.forEach(function (country) {
            country.name = getCountryName(country);
        });

        $scope.watchCountries = function (items, oldItems) {
            if (items === oldItems) {
                return;
            }

            $scope.wizardForm.$setValidity('countries', angular.isArray(items) && items.length > 0);
        };

        $scope.$watch('zone.countries', $scope.watchCountries, true);

        $scope.prev = function () {
            if ($scope.step > 1) {
                $scope.step--;
            }
        };

        $scope.next = function () {
            $scope.step++;
            $('.wizard-fixed .modal-body').scrollTop(0);
        };

        $scope.getCountryByCode = function (code) {
            if (code && $scope.countries[code]) {
                return $scope.countries[code];
            }

            return null;
        };

        $scope.getStateByCode = function (countryCode, stateCode) {
            if ($scope.states[countryCode] && $scope.states[countryCode][stateCode]) {
                return $scope.states[countryCode][stateCode];
            }

            return null;
        };

        $scope.hasStates = function (countryCode) {
            return $scope.states.hasOwnProperty(countryCode);
        };

        $scope.hasSelectedStates = function (countryCode) {
            var result = false;

            $scope.zone.countries.forEach(function (country) {
                if (country.code == countryCode) {
                    result = country.states.length > 0;
                }
            });

            return result;
        };

        $scope.selectCurrentCountry = function () {
            $scope.addCountry($scope.selectedCountry, null);

            if (!$scope.hasStates($scope.selectedCountry)) {
                $scope.selectedCountry = null;
            }

            $scope.selectedState = null;
        };

        $scope.selectCurrentState = function () {
            $scope.addCountry($scope.selectedCountry, $scope.selectedState);

            if ($scope.selectedState == 'all') {
                $scope.selectedCountry = null;

                // for some reason selector value doesn't clear automatically there, so we fix it by triggering ng-change event
                $timeout(function () {
                    angular.element($('[ng-model="selectedCountry"]')[0]).val('').change();
                });
            }

            $scope.selectedState = null;
        };

        $scope.addAllCountries = function () {
            $scope.zone.countries.forEach(function (country) {
                $scope.removeCountry(country.code);
            });

            Object.keys($scope.countries).forEach(function (code) {
                if (!code) {
                    return;
                }

                var name = $scope.countries[code];

                var zoneCountry = {
                    name: name,
                    code: code,
                    states: []
                };

                if ($scope.states[code]) {
                    Object.keys($scope.states[code]).forEach(function (stateCode) {
                        zoneCountry.states.push({
                            name: $scope.states[code][stateCode],
                            code: stateCode
                        });
                    });
                }

                $scope.zone.countries.push(zoneCountry);
            });
        };

        $scope.addAllStates = function (countryCode) {
            if (!$scope.states[countryCode]) {
                return;
            }

            $scope.removeCountry(countryCode);

            var zoneCountry = {
                name: $scope.countries[countryCode],
                code: countryCode,
                states: []
            };

            Object.keys($scope.states[countryCode]).forEach(function (stateCode) {
                zoneCountry.states.push({
                    name: $scope.states[countryCode][stateCode],
                    code: stateCode
                });
            });

            zoneCountry.name = getCountryName(zoneCountry);

            $scope.zone.countries.push(zoneCountry);
        };

        $scope.addCountry = function (countryCode, stateCode) {
            if (countryCode == 'all') {
                $scope.addAllCountries();
                return;
            }

            var country = $scope.getCountryByCode(countryCode);
            var state = $scope.getStateByCode(countryCode, stateCode);

            if ($scope.hasStates(countryCode) && stateCode == 'all') {
                $scope.addAllStates(countryCode);
                return;
            }

            if (country && (!$scope.hasStates(countryCode) || stateCode)) {
                var existingCountry = {
                    code: countryCode,
                    name: country,
                    states: []
                };

                if (!$scope.isAdded(countryCode)) {
                    $scope.zone.countries.push(existingCountry);
                } else {
                    $scope.zone.countries.forEach(function (zoneCountry) {
                        if (zoneCountry.code == countryCode) {
                            existingCountry = zoneCountry;
                        }
                    });
                }

                if (state && !$scope.isAdded(countryCode, stateCode)) {
                    existingCountry.states.push({
                        code: stateCode,
                        name: state
                    });

                    existingCountry.name = getCountryName(existingCountry);
                }
            }
        };

        $scope.isAdded = function (countryCode, stateCode) {
            if (!stateCode) {
                for (var index in $scope.zone.countries) {
                    var country = $scope.zone.countries[index];

                    if (country.code == countryCode) {
                        return true;
                    }
                }

                return false;
            }

            for (var index in $scope.zone.countries) {
                var country = $scope.zone.countries[index];

                if (country.code == countryCode) {
                    for (var stateIndex in country.states) {
                        var state = country.states[stateIndex];

                        if (state.code == stateCode) {
                            return true;
                        }
                    }
                }
            }

            return false;
        };

        $scope.showSelectedStates = function (countryCode) {
            if ($scope.hasStates(countryCode)) {
                $scope.selectedCountry = countryCode;
            }
        };

        $scope.getSelectedCountryIndex = function () {
            var out = -1;

            $scope.zone.countries.forEach(function (country, index) {
                if (country.code == $scope.selectedCountry) {
                    out = index;
                }
            });

            return out;
        };

        $scope.removeCountry = function (countryCode) {
            $scope.zone.countries.forEach(function (country, index) {
                if (country.code == countryCode) {
                    $scope.zone.countries.splice(index, 1);

                    $scope.countries[country.code] = $scope.originalCountries[country.code];
                }
            });
        };

        $scope.removeState = function (countryCode, stateCode) {
            $scope.zone.countries.forEach(function (country, countryIndex) {
                if (country.code != countryCode) {
                    return;
                }

                country.states.forEach(function (state, stateIndex) {
                    if (state.code == stateCode) {
                        country.states.splice(stateIndex, 1);
                        $scope.states[country.code][state.code] = state.name;
                    }
                });

                if (country.states.length == 0) {
                    $scope.zone.countries.splice(countryIndex, 1);
                    $scope.countries[country.code] = $scope.originalCountries[country.code];
                } else {
                    country.name = getCountryName(country);
                }
            });
        };

        $scope.shippingCostTypeChanged = function () {
            if ($scope.zone.shippingCostType == 2) {
                $scope.zone.shippingCost = {
                    val: 0
                };
            } else {
                $scope.zone.shippingCost = [];
            }
            if ($scope.zone.shippingCostType == 1) {
                addShippingOption();
            }
        };

        $scope.validateForm = function (form) {
            if (form.$invalid || form.$pending) {
                form.$setTouched();
                $scope.watchCountries($scope.zone.countries);

                return false;
            }

            return true;
        };

        $scope.save = function (form) {
            if (!$scope.validateForm(form)) {
                return;
            }

            $uibModalInstance.close($scope.zone);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }]);
